<template>
  <div class="gallery container">
    <div
      class="pagination"
      v-if="
        filteredImages &&
        (filteredImages[id].length >= itemsPerPage || page >= 2)
      "
    >
      <router-link
        v-if="page >= 2"
        :to="{ path: `${id.toLowerCase()}`, query: { page: page - 1 } }"
        >Prev</router-link
      >
      <router-link
        v-if="filteredImages[id].length >= itemsPerPage"
        :to="{ path: `${id.toLowerCase()}`, query: { page: page + 1 } }"
        >Next</router-link
      >
    </div>
    <section>
      <h1>{{ id }}</h1>
      <viewer @inited="inited" :trigger="click">
        <ul v-if="filteredImages" class="images" @click="click = true">
          <li
            v-for="(img, index) in page
              ? filteredImages[id].slice((page - 1) * 12, itemsPerPage)
              : filteredImages[id]"
            :key="index"
            @click="click = true"
          >
            <progressive-background
              :src="img.thumbnail"
              :placeholder="placeholder"
            >
            </progressive-background>
            <div class="content-container absolute-bottom">
              <img
                class="slider-img absolute-bottom"
                :ref="`sliderImage${index}`"
                :src="click ? img.url : null"
                :title="img.title"
                :alt="img.description"
              />
              <div class="img-content absolute-bottom">
                <p>{{ img.title }}</p>
                <p>{{ img.description }}</p>
              </div>
            </div>
          </li>
        </ul>
      </viewer>
    </section>
  </div>
</template>

<script>
import Viewer from 'v-viewer';
import Vue from 'vue';
import 'viewerjs/dist/viewer.css';
import placeholder from '../assets/placeholder.png';
import API from '../mixins/api';

Vue.use(Viewer, {
  defaultOptions: {
    inline: false,
    button: true,
    navbar: true,
    title: false,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: false,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'src',
    hide() {
      const active = document.activeElement;
      if (active && typeof active.blur === 'function') {
        active.blur();
      }
    },
  },
});

export default {
  data() {
    return {
      placeholder,
      click: false,
      page: null,
      id: null,
    };
  },
  mixins: [API],
  created() {
    this.setData();
  },
  watch: {
    $route: 'setData',
  },
  methods: {
    setData() {
      this.page = parseInt(this.$route.query.page, 10);
      this.id = this.$route.params.id;
      this.itemsPerPage = this.page * 12;
    },
    inited(viewer) {
      this.$viewer = viewer;
      if (this.click) {
        this.show();
      }
    },
    show() {
      this.$viewer.show();
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  text-transform: capitalize;
}
ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
li {
  position: relative;
  width: 100%;
  margin-bottom: mm(2);
  cursor: pointer;
  &:hover {
    .img-content {
      opacity: 1;
    }
  }
  @include respond-to(medium) {
    width: 30%;
    margin-right: 3.33%;
  }
}
.content-container {
  height: 100%;
  z-index: zindex(page);
}
.slider-img {
  height: 100%;
  opacity: 0;
}
.img-content {
  padding: spacing(element);
  transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1);
  opacity: 1;
  z-index: zindex(page);
  color: color(white);
  background: rgba(0, 0, 0, 0.78);
  @include respond-to(medium) {
    opacity: 0;
  }
  p {
    margin: 0;
  }
}
.pagination {
  padding-top: mm(3);
  a {
    padding-right: mm(1);
    font-size: ms(1);
    @include respond-to(medium) {
      font-size: inherit;
    }
  }
}
.viewer-backdrop {
  background: rgba(0, 0, 0, 0.75);
}
</style>
